// Reminder action types
export const FETCH_CALL_LOGS = "FETCH_CALL_LOGS";
export const FETCH_IVR_MENUS = "FETCH_IVR_MENUS";
export const SYNC_IVR_MENUS = "SYNC_IVR_MENUS";
export const SYNC_EXTENSIONS = "SYNC_EXTENSIONS";
export const FETCH_CUSTOMER_INFO = "FETCH_CUSTOMER_INFO";
export const FETCH_CALL_DETAIL = "FETCH_CALL_DETAIL";
export const UPDATE_CALL_LOG = "UPDATE_CALL_LOG";
export const FETCH_QUEUE_CALLS = "FETCH_QUEUE_CALLS";
export const FETCH_CALL_STATS = "FETCH_CALL_STATS";
export const FETCH_CALL_LOGS_DETAILS = "FETCH_CALL_LOGS_DETAILS";

export const FETCH_CALL_LOGS_GET_EXTENSIONS = "FETCH_CALL_LOGS_GET_EXTENSIONS";

// Success/Failure types (optional)
export const API_SUCCESS = "API_SUCCESS";
export const API_FAILURE = "API_FAILURE";
